/*
 * @Date: 2021-11-01 16:15:06
 * @LastEditTime: 2025-11-01 14:29:17
 */
import * as React from 'react'
import HomeSwiper from '../HomSwiper/HomeSwiper'
import HomeMenu from '../HomeMenu/HomeMenu'
// import HomeGuessYouLike from '../HomeGuessYouLike/HomeGuessYouLike'
import HomeModuleController from '../HomeModuleController/HomeModuleController'
import HomeRecommendModule from '../HomeRecommendModule/HomeRecommendModule'
import HomeType from '../../types/HomeType'
import {HttpServer} from '@/services/server'
import globalBus from '@/services/Bus'
// import { MemberShipAd } from '@/plugins/MemberShipAd'
import Loading from '@/components/Loading/Loading'
// import { HomeTrainingCamp } from '../HomeTrainingCamp/HomeTrainingCamp.tsx'
// import { YkCmp } from '../QianKun/yk_cmp'
import style from './index.module.less'
import { globalWKLink } from '@/utils/tools'

declare const Session: any

interface HomeState {
    indexData: {
        guess_lectures: HomeType.GuessLecture[] | [],
        banner: HomeType.Banner[] | [],
        modules: HomeType.Module[] | [],
        quick_entries: HomeType.QuickEntry[] | [],
        category: HomeType.Category[] | []
    }
}

interface AdConfig {
    switch: boolean
    show_ts: number
    images: Array<{ image_url: string, jump_url: string }>
}

export function HomeContent() {

    const [indexData, setIndexData] = React.useState<HomeState>(null)
    const [adConfig, setAdConfig] = React.useState<AdConfig>({
        switch: false,
        show_ts: 5,
        images: []
    })

    const renderAdImg = () => {
        if (!adConfig.switch) {
            return null
        }
        if (adConfig.images.length === 1) {
            return (
                <div className={style.adImgWrapper} onClick={() => setTimeout(() => window.location.assign(adConfig.images[0].jump_url), 200)}>
                    <img className={style.clickableImg} src={adConfig.images[0].image_url} alt="" />
                </div>
            )
        }

        if (adConfig.images.length > 1) {
            const content = adConfig.images.map(item => ({ image: item.image_url, url: item.jump_url, banner_type: 'image', object_id: null }))
            return (
                <HomeSwiper content={content} interval={adConfig.show_ts ? adConfig.show_ts * 1000 : 5000} />
            )
        }

        return null
    }

    React.useEffect(() => {
        const step = 1000 * 5 * 60 // 五分钟后缓存失效重拿接口
        const getRequestDataFromStorage = JSON.parse(window.sessionStorage.getItem('HOMEPAGE/INDEX/REQUEST_DATA'))
        if (getRequestDataFromStorage && ( new Date().getTime() - parseInt(getRequestDataFromStorage.time, 10) < step && window.location.host !== 'dbg.lizhiweike.com' ) ) {
            setIndexData(getRequestDataFromStorage.data)
        } else {
            try {
                HttpServer.addMoniter()
            } catch (e) {
                console.log(e)
            }
            HttpServer.getHomeData().then((res) => {
                if (res.data.code === 0 ) {
                    setIndexData(res.data.data)
                    const setData = {
                        data: res.data.data,
                        time: new Date().getTime()
                    }
                    window.sessionStorage.setItem('HOMEPAGE/INDEX/REQUEST_DATA', JSON.stringify(setData))
                }
            })
        }
        document.title = '发现'
        if (Session.weixinApi) {
            const shareData = {
                title: '伴你成长每时每刻',
                link:  window.location.href,
                desc: '专注于大众知识分享的线上教育平台',
                imgUrl: 'https://static-cos.lycheer.net/xupload/20210722_msg_img_default.png'
            }
            const timeShareData = {
                ...shareData,
                link: `${globalWKLink.share}`
            }

            Session.weixinApi.wxShare([shareData, timeShareData])
        }
        globalBus.emit({categoryActiveId: 0})

        // 获取广告位配置
        HttpServer.getWhitelistConfigs({
            keys: 'h5_weike_banner_config',
            version: '1.0',
            server_name: 'weike'
        }).then(res => {
            const data = res.data.data
            if (data[0] && data[0].value && data[0].value.index) {
                const { switch: showAd = false, show_ts = 5, images = [] } = data[0].value.index
                setAdConfig({
                    switch: showAd,
                    show_ts,
                    images
                })
            }
        }).catch(err => {
            console.log(err)
        })
    }, [])

    if (indexData && indexData !== null) {
        return (
            <div className="HomeContent">
                <div style={{backgroundColor: '#fff'}}>
                    {/* 轮播banner */}
                    <HomeSwiper content={indexData.banner}/>
                    {/* icon */}
                    <HomeMenu content={indexData.quick_entries}/>
                </div>

                {/* 增加一个广告介绍图 */}
                {renderAdImg()}

                {/* 微应用 */}
                {/* {['m.lizhiweike.com', 'm1.lizhiweike.com'].includes(location.hostname) && <YkCmp />} */}

                {/*  下掉老的训练营代码，由组件化配置 */}
                {/* <HomeTrainingCamp /> */}
                {/* <MemberShipAd/> */}
                {/* feed流 */}
                <HomeModuleController content={indexData.modules}/>
                {/* <HomeGuessYouLike content={indexData.guess_lectures}/> */}
                {/* 滚动加载-更多精选 */}
                <HomeRecommendModule/>
            </div>
        )
    } else {
        return <Loading/>
    }
}



// WEBPACK FOOTER //
// ./src/views/Home/components/HomeContent/HomeContent.tsx